import React, { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import {
  DomainObject,
  TableFieldCellProps,
  TableFieldCells,
  TableFieldColumn,
} from '@eas/common-web';
import { MobileUnitAssignment } from '@models';
import { universalUserLabelMapper } from '@utils';

export function useColumns<T extends DomainObject>(): TableFieldColumn<T>[] {
  const intl = useIntl();

  return [
    {
      name: intl.formatMessage({
        id: 'ZSD__MOBILE_UNIT__ASSIGNMENT__TABLE__COLUMN__LEAD',
        defaultMessage: 'Vedúci',
      }),
      datakey: 'leadTechnician',
      width: 200,
      CellComponent: (props) => (
        <TableFieldCells.TextCell
          {...props}
          value={universalUserLabelMapper(props.value)}
        />
      ),
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__MOBILE_UNIT__ASSIGNMENT__TABLE__COLUMN__TECHNICIANS',
        defaultMessage: 'Technici',
      }),
      datakey: 'technicians',
      width: 200,
      CellComponent: (props) => (
        <TableFieldCells.TextCell
          {...props}
          value={universalUserLabelMapper(props.value)}
        />
      ),
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__MOBILE_UNIT__ASSIGNMENT__TABLE__COLUMN__VALID_FROM',
        defaultMessage: 'Platnosť',
      }),
      datakey: 'validFrom',
      sortkey: 'validFrom',
      width: 350,
      CellComponent: MobileUnitAssignmentValidityTableCell,
    },
  ];
}

export const MobileUnitAssignmentValidityTableCell = <T,>(
  props: PropsWithChildren<TableFieldCellProps<T>>
) => {
  const validFrom = (props.rowValue as unknown as MobileUnitAssignment)
    .validFrom;

  const validTo = (props.rowValue as unknown as MobileUnitAssignment).validTo;

  const value = (
    <>
      {validFrom && (
        <>
          {new Date(validFrom).toLocaleDateString('sk-SK', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })}
          {' | '}
          {new Date(validFrom).toLocaleTimeString('sk-SK', {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </>
      )}
      {validTo && (
        <>
          {' - '}
          {new Date(validTo).toLocaleDateString('sk-SK', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })}
          {' | '}
          {new Date(validTo).toLocaleTimeString('sk-SK', {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </>
      )}
    </>
  );

  return <TableFieldCells.TextCell {...props} value={value} />;
};
